
import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Order, OrderCollection } from '@/firestore'
import store, { Mutations } from '../../../store'

@Component
export default class OverviewList extends Mixins(IconsMixin, AuthMixin) {
  public restaurantOrders: Order[] = []
  public vendorOrders: Order[] = []

  // alert snackbar
  public showAlertSnackbar = false
  public alertSnackbarMessage = ''

  public async mounted() {
    const collection = new OrderCollection((await this.$firebase).firestore())

    const childCompanies = Object.values(this.companies).filter(company => company.adminCompanyId === this.userCompany.id)
    const childCompanyIds: string[] = []
    childCompanies.forEach(company => childCompanyIds.push(company.id))

    this.restaurantOrders = await collection.watchOrdersByCompanyIds(childCompanyIds)
    this.vendorOrders = await collection.watchVendorOrdersByRestaurantIds(childCompanyIds)

    if (store.state.error && store.state.error.message) {
      this.alertSnackbarMessage = `Error: ${store.state.error.message}`
      this.showAlertSnackbar = true

      store.commit(Mutations.UPDATE_ERROR, {error: null})
    }
  }

  public get ordersPlacedToday() {
    if (!this.restaurantOrders) {
      return 0
    }

    return this.restaurantOrders.filter(order => {
      if (order.datePlaced) {
        return this.isToday(order.datePlaced)
      }
    }).length
  }

  public get ordersCheckedInToday() {
    if (!this.vendorOrders) {
      return 0
    }

    return this.vendorOrders.filter(order => {
      if (order.dateCheckedIn) {
        return this.isToday(order.dateCheckedIn)
      }
    }).length
  }

  public get currentlyOutstandingOrders() {
    if (!this.restaurantOrders) {
      return 0
    }

    return this.restaurantOrders.filter(order => {
      return !order.isComplete
    }).length
  }

  public isToday(date: Date) {
    const todaysDate = new Date()

    return date.getFullYear() === todaysDate.getFullYear() &&
        date.getMonth() === todaysDate.getMonth() &&
        date.getDate() === todaysDate.getDate()
  }
}

